import { render } from "./CompanyShopProfile.vue?vue&type=template&id=99834b02&scoped=true"
import script from "./CompanyShopProfile.vue?vue&type=script&lang=js"
export * from "./CompanyShopProfile.vue?vue&type=script&lang=js"

import "./CompanyShopProfile.vue?vue&type=style&index=0&id=99834b02&scoped=true&lang=css"
import "./CompanyShopProfile.vue?vue&type=style&index=1&id=99834b02&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99834b02"]])

export default __exports__